<template>
  <div
    ref="targetRef"
    class="convo-search"
  >
    <div class="convo-search-inner tiles">
      <Scroller
        :items="suggestedAnswers?.values"
        :has-chevrons="hasChevrons"
        :class="{'treatment-padding':showAllFilters}"
      >
        <template #title>
          <div class="convo-search-header">
            <h2 class="h4 text-center">
              {{ searchResult?.followupQuestion }}
            </h2>
            <AllFiltersButton v-if="showAllFilters && !isMew" />
          </div>
        </template>

        <template #item="{ data, index }">
          <ConvoSearchTile
            :key="index"
            :value="data.displayName"
            :name="suggestedAnswers?.name"
            @click="onSelect(suggestedAnswers?.name, data)"
          />
        </template>

        <template #footer>
          <div
            v-if="showAllFilters && isMew"
            class="convo-search-footer"
          >
            <AllFiltersButton />
          </div>
        </template>
      </Scroller>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import useIsIpad from '@common-vue/product-thumbnail/src/composables/useIsIpad';
import Scroller from '@components/Scroller/Scroller';
import { useDevice } from '@modules/discovery/composables';
import ConvoSearchTile from './ConvoSearchTile';
import AllFiltersButton from './AllFiltersButton';
import useConvoSearch from '../../composables/useConvoSearch';

const props = defineProps({
  multiple: {
    type: Boolean,
  },
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  hasChevrons: {
    type: Boolean,
  },
  experiment: {
    type: String,
  },
});

const { onSelect, targetRef } = useConvoSearch(props);
const suggestedAnswers = computed(() => props.searchResult?.suggestedAnswers);

const isIpad = useIsIpad();
const { isDesktop } = useDevice();
const isMew = ref(!isDesktop || isIpad.value);

const showAllFilters = props?.experiment === '2465-23';
</script>

<style lang="scss" scoped>
.convo-search {
  width: calc(100% - 1.5rem);;
  margin: 1rem 0.75rem;
  display: flex;
  justify-content: center;
}

.convo-search-inner {
  max-width: 77.1875rem;
  width: 100%;
}
/** moved these rules to convo-search.scss due to CLS issue
.convo-search-header{
  position: relative;
  margin-bottom: 1.5rem;

  .btn-all-filters{
    position: absolute;
    right: 0;
    top:50%;
    transform: translateY(-50%);
  }
}*/

.convo-search-footer{
  display: flex;
  justify-content: center;
  margin-top: rem-calc(24px);
}
</style>

<style lang="scss" brand="mcom" scoped>
.convo-search-inner {
  border-radius: var(--XS, 16px);
  background: var(--macys-gray-5, #E6E6E6);
}

.convo-search-header{
  .btn-all-filters{
    right: 19.5px;
  }
}
</style>
<style lang="scss" brand="bcom" scoped>
.convo-search-inner {
  background: var(--bloom-gray-5, #EEE);
}
</style>
